import { SHARED_ROUTES } from "definitions/constants/routeConstants";

import { GoChecklist } from "react-icons/go";
import { FiCalendar, FiHome } from "react-icons/fi";
import { SidebarSection } from "./shared";

const newHireHome = {
  id: "home",
  name: "Home",
  route: SHARED_ROUTES.newHirePortal,
  icon: FiHome,
  routeMatchExact: true,
};

const newHireTasks = {
  id: "tasks",
  name: "Tasks",
  route: SHARED_ROUTES.newHireTasks,
  icon: GoChecklist,
};

const newHireSchedule = {
  id: "schedule",
  name: "Schedule",
  route: SHARED_ROUTES.newHireSchedule,
  icon: FiCalendar,
};

const newHireDashboardItems: SidebarSection[] = [
  {
    id: "dashboard",
    items: [newHireHome, newHireTasks, newHireSchedule],
  },
];

export default newHireDashboardItems;
